import { CircularProgress } from "@mui/material";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import img from "../../assets/bill2.png";
import { useState } from "react";
import ImageUploader from "../InventoryUI/ImageUploader";
import { Link } from "react-router-dom";
import { CrmUseProfile } from "../../features/Crm/CrmProfile/CrmUseProfile";
import CrmSelectField from "./CrmProfileUI/CrmSelectField";

const CrmRegistrationUI = ({ login, user, updateState, isLoading }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const [step, setStep] = useState(1);
    const { states } = CrmUseProfile();

    return (
        <div className="flex min-h-screen">
            {/* Left Side - Image */}
            <div className="hidden lg:flex md:w-1/2 relative items-center justify-center bg-gradient-to-tr from-[#47c592] to-[#0a3021] ">
                {/* Welcome Text */}
                <div className="absolute top-[25%] left-[-10%] rotate-[-90deg] text-white font-bold text-5xl opacity-80 z-20">
                    Welcome !
                </div>
                {/* Slanted Overlay */}
                <div
                    className="absolute top-0 left-0 w-full h-full bg-[#0a3021]"
                    style={{
                        clipPath: "polygon(0 0, 75% 0, 50% 100%, 0% 100%)",
                    }}
                ></div>
                {/* Image */}
                <img
                    src={img}
                    alt="Welcome Back"
                    className="max-w-[480px] max-h-full object-cover z-10 ml-4"
                />
            </div>

            {/* Right Side - Form */}
            <div className="w-full lg:w-1/2 p-10 pt-24">
                <div className="max-w-md mx-auto">
                    <h1 className="text-4xl font-bold mb-6 text-[#131212]">
                        Register Your Business
                    </h1>

                    <form>
                        {/* Step 1: Personal Info */}
                        {step === 1 && (
                            <>
                                {/* User name */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Your name"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.userName}
                                        name="userName"
                                        onChange={(e) => updateState({ userName: e.target.value })}
                                    />
                                </div>

                                {/* telephone number */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Phone number
                                    </label>
                                    <input
                                        type="number"
                                        placeholder="90254865XX"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.telephone}
                                        name="telephone"
                                        onChange={(e) => updateState({ telephone: e.target.value })}
                                    />
                                </div>

                                {/* Email Id */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        placeholder="name@example.com"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.email}
                                        name="email"
                                        onChange={(e) => updateState({ email: e.target.value })}
                                    />
                                </div>

                                {/* Role Dropdown */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Role
                                    </label>
                                    <select
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.role}
                                        name="role"
                                        onChange={(e) => updateState({ role: e.target.value })}
                                    >
                                        <option value="">Select Role</option>
                                        <option value="admin">Admin</option>
                                        <option value="sales">Sales</option>
                                    </select>
                                </div>

                                {/* Next Button */}
                                <button
                                    type="button"
                                    onClick={() => setStep(2)}
                                    className="w-full bg-[#0a3021] text-white p-3 rounded"
                                >
                                    {isLoading && <CircularProgress color="inherit" size={12} />}
                                    Next →
                                </button>
                            </>
                        )}

                        {/* Step 2: Business Info */}
                        {step === 2 && (
                            <>
                                {/* Company Name */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Company Name
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter company name"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.companyName}
                                        name="companyName"
                                        onChange={(e) => updateState({ companyName: e.target.value })}
                                    />
                                </div>

                                {/* GSTIN */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        GSTIN
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="GST number"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.gstin}
                                        name="gstin"
                                        onChange={(e) => updateState({ gstin: e.target.value })}
                                    />
                                </div>

                                {/* Address */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Business Address
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter business address"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.address}
                                        name="address"
                                        onChange={(e) => updateState({ address: e.target.value })}
                                    />
                                </div>

                                {/* State */}
                                {/* <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        State
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter your State"
                                        className="w-full p-2 border border-gray-300 rounded mt-2"
                                        value={user.state}
                                        name="state"
                                        onChange={(e) => updateState({ state: e.target.value })}
                                    />
                                </div> */}

                                <div className="mb-6">
                                    <CrmSelectField label="State" name="state" value={user.state} onChange={(e) => updateState({ state: e.target.value })} options={states} />
                                </div>

                                {/* Image Uploader */}
                                <div className="mb-6">
                                    <label className="block text-black font-semibold uppercase">
                                        Business Logo
                                    </label>
                                    <ImageUploader
                                        selectedImage={user.profile_image}
                                        setSelectedImage={(file) => updateState({ profile_image: file })}
                                        error={user.error}
                                        setError={(err) => updateState({ error: err })}
                                    />

                                </div>
                                {/* Back + Next Button */}
                                <div className="flex gap-4">
                                    <button
                                        type="button"
                                        onClick={() => setStep(1)}
                                        className="w-1/2 bg-gray-400 text-white p-3 rounded"
                                    >
                                        ← Back
                                    </button>
                                    <button
                                        type="Next"
                                        onClick={() => setStep(3)}
                                        // onClick={(e) => login(e)}
                                        className="w-1/2 bg-[#0a3021] text-white p-3 rounded"
                                    >
                                        {isLoading && (
                                            <CircularProgress color="inherit" size={12} />
                                        )}
                                        Next →
                                    </button>
                                </div>
                            </>
                        )}

                        {/* Step 3: Password */}
                        {step === 3 && (
                            <>
                                {/* create password */}
                                <div className="mb-6 relative">
                                    <label className="block text-black font-semibold uppercase">
                                        Create Password
                                    </label>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="at least 8 characters"
                                        className="w-full p-2 border border-gray-300 rounded mt-2 pr-10"
                                        value={user.password}
                                        name="password"
                                        onChange={(e) => updateState({ password: e.target.value })}
                                    />
                                    <div
                                        className="absolute inset-y-0 right-0 top-7 pr-3 flex items-center text-[#0a3021] text-lg cursor-pointer"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>

                                {/* Confirm password */}
                                <div className="mb-6 relative">
                                    <label className="block text-black font-semibold uppercase">
                                        Confirm Password
                                    </label>
                                    <input
                                        type={showConfPassword ? "text" : "password"}
                                        placeholder="at least 8 characters"
                                        className="w-full p-2 border border-gray-300 rounded mt-2 pr-10"
                                        value={user.confirmPassword}
                                        name="confirmPassword"
                                        onChange={(e) => updateState({ confirmPassword: e.target.value })}
                                    />
                                    <div
                                        className="absolute inset-y-0 right-0 top-7 pr-3 flex items-center text-[#0a3021] text-lg cursor-pointer"
                                        onClick={() => setShowConfPassword(!showConfPassword)}
                                    >
                                        {showConfPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>

                                {/* Back + Register Button */}
                                <div className="flex gap-4">
                                    <button
                                        type="button"
                                        onClick={() => setStep(2)}
                                        className="w-1/2 bg-gray-400 text-white p-3 rounded"
                                    >
                                        ← Back
                                    </button>
                                    <button
                                        type="Next"
                                        onClick={(e) => login(e)}
                                        className="w-1/2 bg-[#0a3021] text-white p-3 rounded"
                                    >
                                        {isLoading && (
                                            <CircularProgress color="inherit" size={12} />
                                        )}
                                        Register →
                                    </button>
                                </div>
                            </>
                        )}
                    </form>
                    <Link
                        to="/crm/login"
                        className="block text-sm font-semibold mb-1 text-center mt-10"
                    >
                        Have an account?{" "}
                        <span className="text-[#0a3021]">Login</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default CrmRegistrationUI;
